import { Config } from 'src/app/interfaces/shared/config';
export type ViewerMaterialKey = keyof typeof ViewerMaterials;


export const ViewerMaterials = {
    todoMaterial: new THREE.MeshBasicMaterial({
        name: "todoMaterial",
        side: THREE.DoubleSide,
        color: Config.colors.warning,
    }),
    doneMaterial: new THREE.MeshBasicMaterial({
        name: "doneMaterial",
        side: THREE.DoubleSide,
        color: Config.colors.warning,
    }),
    progressMaterial: new THREE.MeshBasicMaterial({
        name: "progressMaterial",
        side: THREE.DoubleSide,
        color: Config.colors.warning,
    }),
    lateMaterial: new THREE.MeshBasicMaterial({
        name: "lateMaterial",
        side: THREE.DoubleSide,
        color: Config.colors.warning,
    }),
    aheadMaterial: new THREE.MeshBasicMaterial({
        name: "aheadMaterial",
        side: THREE.DoubleSide,
        color: Config.colors.warning,
    }),
    unusedMaterial: new THREE.MeshBasicMaterial({
        name: "unusedMaterial",
        side: THREE.DoubleSide,
        color: Config.colors.info,
    }),
    fragmentObjectMaterial: new THREE.MeshBasicMaterial({
        name: "fragmentObjectMaterial",
        side: THREE.DoubleSide,
        color: Config.colors.dark,
    }),
    pathMaterial: new THREE.LineBasicMaterial({
        color: 0x000000,
        transparent: false,
        linewidth: 10,
        depthTest: false,       // visible même derrière d'autres objets
        depthWrite: false,
    }),
    reinforcement: new THREE.MeshPhongMaterial({
        name: "reinforcement",
        // color: this.colors.worker
    }),
    floor: new THREE.MeshPhongMaterial({
        name: "floor",
        // color: this.colors.worker
    }),
    formwork: new THREE.MeshPhongMaterial({
        name: "formwork",
        // color: this.colors.worker
    }),
    concreting: new THREE.MeshPhongMaterial({
        name: "concreting",
        // color: this.colors.worker
    }),
    column: new THREE.MeshPhongMaterial({
        name: "column",
        // color: this.colors.worker
    }),
    beam: new THREE.MeshPhongMaterial({
        name: "beam",
        // color: this.colors.worker
    }),
    wall: new THREE.MeshPhongMaterial({
        name: "wall",
        // color: this.colors.worker
    }),
    precast_slab: new THREE.MeshPhongMaterial({
        name: "precast_slab",
        // color: this.colors.worker
    }),
    other: new THREE.MeshPhongMaterial({
        name: "other",
        // color: this.colors.worker
    }),
    metric: new THREE.MeshPhongMaterial({
        name: "metric",
        color: Config.colors.primary
    }),
    default: new THREE.MeshPhongMaterial({
        name: "default",
        color: Config.colors.primary
    })
}

export default ViewerMaterials;